import React from "react";
import { STATUS_META } from "../lib/format";

export function StatusBadge({ status, className = "" }) {
  const meta = STATUS_META[status] || STATUS_META.NORMAL;
  return (
    <span data-testid={`status-badge-${status}`}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-[11px] font-semibold uppercase tracking-wider ${meta.cls} ${className}`}>
      {meta.label}
    </span>
  );
}
